import React from 'react';
import { ICONS, iconKeyFor } from './programIcons';
import './programIcon.css';

/**
 * A program's detailed icon on a cream tile, picked from its name (programIcons.js). Decorative:
 * the program name always sits beside it. size is the tile's width and height in pixels.
 */
const ProgramIcon = ({ name, size = 40, className = '' }) => (
  <span className={`pi-tile${className ? ` ${className}` : ''}`} style={{ '--pi-size': `${size}px` }} aria-hidden="true">
    <svg
      viewBox="0 0 64 64"
      focusable="false"
      // The icons are fixed strings written in programIcons.js, never user input.
      dangerouslySetInnerHTML={{ __html: ICONS[iconKeyFor(name)] }}
    />
  </span>
);

export default ProgramIcon;
